import { AuthScene } from '../scenes/auth';

export let Switch = () => {
  return <AuthScene type="switch" />;
};
